import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-tips',
  templateUrl: './info-tips.component.html',
  styleUrls: ['./info-tips.component.scss'],
})
export class InfoTipsComponent implements OnInit {
  /**
   * TODO:
   *  1 - check info-select overflow is not working when there are a log of items
   *  2 - add the rest of the columns
   */

  @Input() type: string;
  @Input() campaignName: string;

  constructor() {
  }

  ngOnInit() {
  }

  getTitle() {
    switch (this.type) {
      case 'follow_up':
      case 'follow_up_2':
        return 'Follow Up';
      case 'cycle_2':
        return 'Cycle';
      case 'inactive_2':
        return 'Inactive';
      case 'remove_2':
        return 'Remove';
      case 'enter_activity':
        return 'Enter Activity';
      case 'ok_got_it':
      case 'ok_got_it_2':
      case 'ok_got_it_popup':
        return 'Keep Current Status';
      case 'active_total':
        return 'Total/Active/In Campaign';
      case 'status':
        return 'Status Of Campaign';
      case 'status_accounts':
        return '';
      case 'content_group':
        return 'Content Group';
      case 'campaign_name':
        return 'Campaign Name';
      case 'select_content':
        return 'Select Content';
      case 'request_help':
        return 'Request Help with Content';
      case 'get_started_with_content':
        return 'Get started with your content';
      case 'fill_in_the_blank':
        return 'Fill in the blank';
      case 'attention_statement':
        return 'Create an attention statement';
      case 'explain_benefits':
        return 'Create 2 benefit statements:';
      case 'detailed_section':
        return 'Detailed Section';
      case 'provide_signature':
        return 'Provide an email signature';
      case 'pipeline_feature':
        return 'Pipeline Feature';
      case 'add_contacts':
        return 'Add Contacts';
      case 'upload_contacts':
        return 'Upload Contacts';
      case 'update_send':
        return 'Update/Send';
      case 'complete_template_preview':
        return '';
      case 'deleted_meetings':
        return 'Deleted Meetings';
      case 'spam':
        return 'Spam Messages';
      case 'vip':
        return 'VIP Feature';
      case 'example_attention':
        return 'Examples';
      case 'one-time-message':
        return 'Onetime Message Warning';
      case 'inbox_status':
        return 'Inbox Status';
      case 'no-match-action':
        return 'No Match Action';
      case 'back_to_campaign':
        return 'Back to Campaign';
      case 'notification_email':
        return 'Notification Emails';
      case 'send-update':
        return 'Update/Send';
      case 'send_email':
      case 'send-email':
        return 'Send Email';
      case 'discount_name':
        return 'Team Code Name';
      case 'discount_product':
        return 'Team Code Product';
      case 'discount_option':
        return 'Discount Option';
      case 'discount_set_up':
        return 'Discount Set Up';
      case 'discount_duration':
        return 'Discount Duration';
      case 'discount_expire_at':
        return 'Discount Expire at';
      case 'discount_times':
        return 'Discount max redemption times';
      case 'discount_domains':
        return 'Discount Domains';
      case 'discount_additional_const':
        return 'Additional Cost';
      case 'lock_domain':
        return 'Lock new Domain';
      case 'default_cycle_period':
        return 'Default Cycle Interval';
      default:
        if (this.type.indexOf('_popup') !== -1) {
          return (
            this.type.split('_')[0].charAt(0).toUpperCase() +
            this.type.split('_')[0].substr(1)
          );
        }
        return this.type.charAt(0).toUpperCase() + this.type.substr(1);
    }
  }
}
